/* Lumin · PDP (galería + sticky + acordeones) */
(function boot(factory){
  const run = () => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', factory, { once:true });
    } else {
      factory();
    }
    document.addEventListener('shopify:section:load', factory);
    document.addEventListener('shopify:section:select', factory);
  };
  run();
})(function initLuminPDP(){
  const root = document.querySelector('.lumin-product');
  if (!root || root.dataset.luminInited === '1') return;
  root.dataset.luminInited = '1';

  /* ---------- ACORDEONES ---------- */
  root.querySelectorAll('[data-accordion-trigger]').forEach(btn => {
    btn.addEventListener('click', () => btn.closest('.accordion-list__item')?.classList.toggle('open'));
  });

  /* ---------- STICKY ---------- */
  const sticky   = root.querySelector('[data-sticky-wrap]');
  const formAnchor = root.querySelector('#lumin-form-sentinel-anchor');
  if (sticky && formAnchor && formAnchor.parentElement){
    const sentinel = document.createElement('div');
    sentinel.id = 'sticky-sentinel'; sentinel.style.cssText = 'height:1px;margin-top:-1px;';
    formAnchor.parentElement.insertBefore(sentinel, formAnchor);

    const headerH = getComputedStyle(root).getPropertyValue('--header-height') || '72px';
    sticky.style.top = (headerH + '').trim();

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(entries => {
        sticky.classList.toggle('active', !entries[0].isIntersecting);
      }, { threshold: 0 });
      io.observe(sentinel);
    } else {
      const onScroll = () => sticky.classList.toggle('active', sentinel.getBoundingClientRect().top < 0);
      document.addEventListener('scroll', onScroll, { passive:true }); onScroll();
    }

    root.querySelector('[data-sticky-add]')?.addEventListener('click', () => {
      const form = root.querySelector('#lumin-product-form');
      if (form) { form.requestSubmit ? form.requestSubmit() : form.submit(); }
    });
  }

  /* ---------- GALERÍA ---------- */
  const slider   = root.querySelector('#LuminSlider');
  const slides   = slider ? Array.from(slider.children) : [];
  const prevBtn  = root.querySelector('.carousel__button--prev');
  const nextBtn  = root.querySelector('.carousel__button--next');
  const thumbsWrap = root.querySelector('#LuminThumbs');
  const thumbs   = thumbsWrap ? Array.from(thumbsWrap.querySelectorAll('.thumb')) : [];
  const navUp    = root.querySelector('.thumbs-nav--up');
  const navDown  = root.querySelector('.thumbs-nav--down');
  let index = 0;

  if (!slider || slides.length === 0) return;

  const setAriaDisabled = (el, val) => el && (val ? el.setAttribute('aria-disabled','true') : el.removeAttribute('aria-disabled'));
  const clamp = (n,a,b) => Math.max(a, Math.min(b, n));

  function updateArrows(){
    setAriaDisabled(prevBtn, index <= 0);
    setAriaDisabled(nextBtn, index >= slides.length - 1);
  }
  function markActiveThumb(){
    thumbs.forEach(t => { t.classList.remove('active'); t.setAttribute('aria-current','false'); });
    if (thumbs[index]) { thumbs[index].classList.add('active'); thumbs[index].setAttribute('aria-current','true'); }
    thumbsWrap && thumbs[index] && thumbs[index].scrollIntoView({ block:'nearest', inline:'nearest', behavior:'smooth' });
  }
  function pauseVideos(){ slides.forEach(s => { const v = s.querySelector('video'); if (v) try{ v.pause(); }catch(_){} }); }
  function goTo(i){
    index = clamp(i, 0, slides.length - 1);
    pauseVideos();
    slider.style.transform = 'translateX(-' + (index * 100) + '%)';
    updateArrows(); markActiveThumb();
  }

  prevBtn && prevBtn.addEventListener('click', () => goTo(index - 1));
  nextBtn && nextBtn.addEventListener('click', () => goTo(index + 1));

  thumbs.forEach(btn => btn.addEventListener('click', () => goTo(parseInt(btn.dataset.index || '0',10))));

  slider.addEventListener('keydown', e => {
    if (e.key === 'ArrowLeft'){ e.preventDefault(); goTo(index - 1); }
    if (e.key === 'ArrowRight'){ e.preventDefault(); goTo(index + 1); }
  });

  // Scroll de miniaturas
  function updateThumbNav(){
    if (!thumbsWrap) return;
    const atTop = thumbsWrap.scrollTop <= 0;
    const atBottom = Math.ceil(thumbsWrap.scrollTop + thumbsWrap.clientHeight) >= thumbsWrap.scrollHeight;
    if (navUp)   setAriaDisabled(navUp,   atTop);
    if (navDown) setAriaDisabled(navDown, atBottom);
  }
  const step = 3 * 96; // ~3 thumbs
  navUp   && navUp.addEventListener('click', () => thumbsWrap.scrollBy({ top: -step, behavior:'smooth' }));
  navDown && navDown.addEventListener('click', () => thumbsWrap.scrollBy({ top:  step, behavior:'smooth' }));
  thumbsWrap && thumbsWrap.addEventListener('scroll', updateThumbNav, { passive:true });

  goTo(0);
  updateThumbNav();
  window.addEventListener('resize', () => { goTo(index); updateThumbNav(); });
});
